<template>
  <v-container fluid class="icons-page">
    <v-row no-gutters class="d-flex justify-space-between mt-5 mb-6">
      <h1 class="page-title">รายการสั่งซื้อ</h1>

      <div v-show="orderheader.orderId != ''">
        เลขที่ใบสั่งซื้อ {{ orderheader.orderId }}
      </div>

      <v-col cols="12">
        <form @submit.prevent="submit" novalidate>
          <v-row>
            <v-col cols="12" md="4">
              <v-menu
                :disabled="input.duedate"
                v-model="menu1"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDateFormattedMomentjs"
                    clearable
                    label="วันที่นัดส่ง"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="orderheader.duedate = null"
                    :error-messages="duedateError"
                    @input="$v.orderheader.duedate.$touch()"
                    @blur="$v.orderheader.duedate.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="orderheader.duedate"
                  @change="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4" class="mb-1">
              <v-select
                :readonly="input.contact"
                :error-messages="contactEror"
                :items="contact"
                item-value="contactId"
                item-text="name"
                v-model="orderheader.contactId"
                clearable
                required
                single-line
                @change="GetTel()"
                @input="$v.contact.$touch()"
                @blur="$v.contact.$touch()"
                label="ผู้ติดต่อ"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :readonly="input.tel"
                label="เบอร์โทร"
                hide-details="auto"
                v-model="orderheader.tel"
                maxlength="50"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :readonly="input.remark"
                v-model="orderheader.remark"
                label="หมายเหตุ"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="6">
              <div class="float-md-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      large
                      fab
                      color="secondary"
                      :disabled="btn.btnadd"
                      @click="add"
                      role="button"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-note-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>เพิ่มข้อมูล</span>
                </v-tooltip>
                
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      :disabled="btn.btnedit"
                      large
                      fab
                      color="orange"
                      @click="edit"
                      role="button"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-tooltip-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>แก้ไขข้อมูล</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      large
                      fab
                      color="warning"
                      :disabled="btn.btnsearch"
                      role="button"
                      @click.stop="modalsearch = true"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>ค้นหาข้อมูลการสั่งซื้อ</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      large
                      fab
                      color="primary"
                      :disabled="btn.btnprint"
                      @click="print"
                      role="button"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>พิมพ์</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card>
                <v-card-title>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="table.search"
                        append-icon="mdi-magnify"
                        label="Filter รายการสินค้าที่สั่ง"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="float-md-right">
                        <v-file-input
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          ref="file"
                          style="display: none;"
                          hide-input
                          id="fileexcel"
                          @change="onfileselected"
                          v-model="fileexcel"
                        />

                        <v-btn
                          class="mx-1"
                          color="success"
                          :disabled="btn.btnselectlist"
                          @click="readExcel"
                        >
                          Upload Excel
                        </v-btn>

                        <v-btn
                          class="mx-1"
                          :disabled="btn.btnselectlist"
                          color="secondary"
                          @click="selectList()"
                        >
                          เลือกรายการสินค้า
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-data-table
                  v-model="table.selected"
                  :headers="table.headers"
                  :items="sortTable"
                  item-key="itemcode"
                  :search="table.search"
                  :loading="table.loading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.item`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.fileType`]="{ item }">
                    <v-icon
                      v-if="item.fileType != ''"
                      @click="getimageitem(item)"
                      small
                      color="green"
                    >
                      mdi-file-image
                    </v-icon>
                  </template>

                  <template v-slot:item.qty="props">
                    <v-text-field
                      :readonly="input.qty"
                      @keypress="isNumber($event)"
                      @input="count"
                      @keyup.enter="focusNext($event.target)"
                      v-model.number="props.item.qty"
                    ></v-text-field>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-icon
                      :disabled="btn.btndelete"
                      @click="removerow(item)"
                      color="red small"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-spacer></v-spacer>
                <v-row>
                  <v-col col="12">
                    <div class="float-right">
                      <v-text-field
                        label="รวมเป็นเงิน/บาท"
                        hide-details="auto"
                        readonly
                        v-model="computedDoctotal"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-6">
            <v-col cols="12">
              <div class="float-md-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      color="success"
                      large
                      fab
                      :disabled="btn.btnsave"
                      role="button"
                      @click="preview()"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-file-find</v-icon>
                    </v-btn>
                  </template>
                  <span>Preview รายการ</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1"
                      large
                      fab
                      color="error"
                      role="button"
                      @click="cancel()"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>ยกเลิก</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
        v-model="modalsearch"
        scrollable
        max-width="1000"
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <v-card>
          <v-card-title>
            <span class="headline">ข้อมูลการสั่งซื้อ</span>
          </v-card-title>
          <v-card-text>
            <v-container class="border">
              <v-form>
                <v-row>
                  <v-col cols="12" md="5">
                    <v-menu
                      v-model="fromdate"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :error-messages="fromdateError"
                          required
                          :value="computedFromDate"
                          clearable
                          label="วันที่"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="search.fromdate = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="search.fromdate"
                        @change="fromdate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-menu
                      v-model="todate"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :error-messages="todateError"
                          :value="computedTodate"
                          clearable
                          label="วันที่"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="search.todate = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="search.todate"
                        @change="todate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="2">
                    <div class="fload-md-right">
                      <v-btn
                        class="mx-1"
                        large
                        fab
                        color="orange"
                        @click="searchmodal"
                      >
                        <v-icon>mdi-file-find</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-data-table
                      v-model="searchmodaldata.selected"
                      :headers="searchmodaldata.headers"
                      :items="searchmodaldata.desserts"
                      item-key="orderId"
                      :search="searchmodaldata.search"
                      :loading="searchmodaldata.loading"
                      loading-text="Loading... Please wait"
                    >
                      <template v-slot:[`item.index`]="{ index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:[`item.createDate`]="{ item }">
                        {{ formatDate(item.createDate) }}
                      </template>

                      <template v-slot:[`item.duedate`]="{ item }">
                        {{ formatDate(item.duedate) }}
                      </template>

                      <template v-slot:[`item.action`]="{ item }">
                        <v-icon
                          small
                          @click="selectheader(item.orderId)"
                          color="red"
                        >
                          mdi-check-circle-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color=" success" text @click="modalsearch = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog
      v-model="dialogimage"
      scrollable
      max-width="550px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row align-content="center">
              <v-col cols="12">
                <v-img
                  :src="imageitem"
                  max-height="360"
                  contain
                  max-width="480"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogimage = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogReview"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title class="text-h5">
          สรุปรายการสั่งซื้อ
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  v-model="tableReview.selected"
                  :headers="tableReview.headers"
                  :items="tableReview.desserts"
                  item-key="itemcode"
                  :loading="tableReview.loading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.item`]="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.fileType`]="{ item }">
                    <v-icon
                      v-if="item.fileType != ''"
                      @click="getimageitem(item)"
                      small
                      color="green"
                    >
                      mdi-file-image
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                v-bind="attrs"
                v-on="on"
                :disabled="btn.btnsaveconfirm"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>บันทึกข้อมูล</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="blue darken-1"
                text
                @click="dialogReview = false"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>ยกเลิก</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogTemplate"
      scrollable
      max-width="1200px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card height="90vh">
        <v-card-title class="text-h5">
          เลือกรายการสินค้า
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col col sm="12" md="12">
                <v-layout row wrap>
                  <v-checkbox
                    class="mr-4"
                    multiple
                    v-for="(data, index) in template"
                    :key="index"
                    :label="data.description"
                    v-model="tableTemplate.filters"
                    :value="data.docEntry"
                  ></v-checkbox>
                </v-layout>

                <!--
                <v-select
                  :items="template"
                  v-model="tableTemplate.filters"
                  item-value="docEntry"
                  item-text="description"
                  class="p-0 m-0"
                  multiple
                  clearable
                  required
                  attach
                  chips
                  label="หมวดสินค้า"
                ></v-select>
                -->
              </v-col>
            </v-row>
            <v-row>
              <v-col col sm="12" md="6">
                <v-text-field
                  v-model="tableTemplate.search"
                  append-icon="mdi-magnify"
                  label="กรองข้อมูล"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  v-model="tableTemplate.selected"
                  :headers="tableTemplate.headers"
                  :items="filteredDesserts"
                  item-key="itemcode"
                  :loading="tableTemplate.loading"
                  :search="tableTemplate.search"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.item`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.fileType`]="{ item }">
                    <v-icon
                      v-if="item.fileType != ''"
                      @click="getimageitem(item)"
                      small
                      color="green"
                    >
                      mdi-file-image
                    </v-icon>
                  </template>

                  <template v-slot:item.qty="props">
                    <v-text-field
                      @keypress="isNumber($event)"
                      v-model.number="props.item.qty"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="selectdata">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn color="blue darken-1" text @click="dialogTemplate = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--overlay image-->
    <!--
    <v-overlay :absolute="absolute" :value="overlay" @click="overlay = false">
      <v-btn color="success" @click="overlay = false">
        Hide Overlay
      </v-btn>
    </v-overlay>-->
  </v-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import config from "@/config";
import VueApexCharts from "vue-apexcharts";
import importexcel from "convert-excel-to-json";

export default {
  data: () => ({
    // date: new Date().toISOString().substr(0, 10),
    modalsearch: false,
    dialogReview: false,
    dialogTemplate: false,

    absolute: true,
    overlay: false,
    

    contact: [],
    template: [],
    templdateRev: "",
    menu1: false,
    fromdate: false,
    todate: false,

    imageitem: "",
    dialogimage: false,
    fileexcel: [],

    btn: {
      btnadd: false,
      btnedit: true,
      btnsearch: false,
      btnprint: true,
      btnselectlist: true,
      btnsave: true,
      btnsaveconfirm: true,
      btndelete: true,
    },

    input: {
      duedate: true,
      tel: true,
      contact: true,
      remark: true,
      qty: true,
      template: true,
    },

    orderheader: {
      id: 0,
      orderId: "",
      duedate: "",
      tel: "",
      customerid: parseInt(localStorage.getItem("customerid")),
      contactId: "",
      remark: "",
      docTotal: 0,
      status: "",
      statusDoc: "N",
    },

    orderitem: [],

    table: {
      search: "",
      selected: [],
      loading: false,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "item",
          width: "10%",
        },
        {
          text: "รหัสสินค้า",
          sortable: true,
          value: "itemCode",
          width: "10%",
        },
        {
          text: "",
          sortable: true,
          value: "fileType",
          width: "2%",
        },
        { text: "ชื่อสินค้า", value: "itemName", width: "50%" },
        { text: "จำนวน", value: "qty", width: "10%", sortable: false },
        { text: "ราคา", value: "price", width: "10%" },
        { text: "หน่วย", value: "ugpName", width: "10%" },
        { text: "ลบ", value: "action", width: "10%" },
      ],
      desserts: [],
      qty: 0,
    },

    tableReview: {
      search: "",
      selected: [],
      loading: false,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "item",
          width: "10%",
        },
        {
          text: "รหัสสินค้า",
          sortable: true,
          value: "itemCode",
          width: "10%",
        },
        {
          text: "",
          sortable: true,
          value: "fileType",
          width: "2%",
        },
        { text: "ชื่อสินค้า", value: "itemName", width: "50%" },
        { text: "จำนวน", value: "qty", width: "10%", sortable: false },
        { text: "ราคา", value: "price", width: "10%" },
        { text: "หน่วย", value: "ugpName", width: "10%" },
      ],
      desserts: [],
    },

    tableTemplate: {
      search: "",
      selected: [],
      loading: false,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "item",
          width: "10%",
        },
        {
          text: "รหัสสินค้า",
          sortable: true,
          value: "itemCode",
          width: "10%",
        },
        {
          text: "",
          sortable: true,
          value: "fileType",
          width: "2%",
        },
        { text: "ชื่อสินค้า", value: "itemName", width: "50%" },
        { text: "จำนวน", value: "qty", width: "10%", sortable: false },
        { text: "ราคา", value: "price", width: "10%" },
        { text: "หน่วย", value: "ugpName", width: "10%" },
      ],
      desserts: [],
      filters: [],
    },

    search: {
      fromdate: "",
      todate: "",
    },

    rules: [
      (value) => !!value || "กรุณาใส่ผู้ติดต่อ",
      //value => (value && value.length >= 3) || 'Min 3 characters',
    ],

    searchmodaldata: {
      search: "",
      selected: [],
      loading: false,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "index",
          //  width: "10%",
        },
        {
          text: "เลขใบสั่งซื้อ",

          sortable: true,
          value: "orderId",
          //  width: "10%",
        },

        {
          text: "วันที่เอกสาร",
          sortable: true,
          value: "createDate",
          //  width: "10%",
        },
        {
          text: "วันที่นัดส่ง",
          sortable: true,
          value: "duedate",
          //   width: "10%",
        },
        {
          text: "หมายเหตุ",
          sortable: true,
          value: "remark",
          width: "20%",
        },
        {
          text: "สถานะ",
          sortable: true,
          value: "statusDesc",
          //   width: "15%",
        },
        {
          text: "เลือก",
          value: "action",
          //  width: "10%",
        },
      ],

      desserts: [],
    },
  }),

  mounted() {
    if (this.$store.state.orderid != undefined) {
      this.selectheader(this.$store.state.orderid);
      this.$store.state.orderid = "";
    }
  },
  

  beforeMount() {
    //this.orderheader.duedate = this.formatDate(new Date());

    this.$http({
      method: "get",
      url: "api/customerorder/GetContact/" + localStorage.getItem("customerid"),
    })
      .then((response) => {
        if (response.status == "200") {
          this.contact = response.data.contacts;
        }
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      });

    var params = new URLSearchParams();
    params.append("Active", "1");
    this.$http({
      method: "get",
      url: "api/customerorder/GetTemplate",
      params: params,
    })
      .then((response) => {
        if (response.status == "200") {
          this.template = response.data.data;
        }
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      });
  },

  computed: {
    filteredDesserts() {
      if (this.tableTemplate.filters.length > 0) {
        return this.tableTemplate.desserts.filter((d) =>
          this.tableTemplate.filters.includes(d.templateId)
        );
      } else {
        return this.tableTemplate.desserts;
      }
    },

    computedDateFormattedMomentjs() {
      return this.orderheader.duedate
        ? moment(this.orderheader.duedate).format("DD/MM/YYYY")
        : "";
    },

    computedFromDate() {
      return this.search.fromdate
        ? moment(this.search.fromdate).format("DD/MM/YYYY")
        : "";
    },

    computedTodate() {
      return this.search.todate
        ? moment(this.search.todate).format("DD/MM/YYYY")
        : "";
    },

    computedDoctotal() {
      return this.formatPrice(this.orderheader.docTotal);
    },

    contactEror() {
      const errors = [];
      if (!this.$v.orderheader.contactId.$dirty) return errors;
      !this.$v.orderheader.contactId.required &&
        errors.push("กรุณาใส่ผู้ติดต่อ");
      return errors;
    },

    duedateError() {
      const errors = [];
      const date = new Date();

      if (!this.$v.orderheader.duedate.$dirty) return errors;
      !this.$v.orderheader.duedate.required &&
        errors.push("กรุณาใส่วันที่นัดส่ง");
      return errors;
    },

    fromdateError() {
      const errors = [];
      //  if (!this.$v.search.fromdate.$dirty) return errors;
      // !this.$v.search.fromdate.required && errors.push("กรุณาใส่วันที่");
      if (this.search.fromdate == "") {
        errors.push("กรุณาใส่วันที่");
      }
      return errors;
    },

    todateError() {
      const errors = [];
      //if (!this.$v.search.todate.$dirty) return errors;
      //!this.$v.search.todate.required && errors.push("กรุณาใส่วันที่");
      if (this.search.todate == "") {
        errors.push("กรุณาใส่วันที่");
      }
      return errors;
    },

    templateError() {
      const errors = [];
      if (!this.$v.template.$dirty) return errors;
      !this.$v.template.required && errors.push("กรุณาเลือกประเภทหนังสือ");
      return errors;
    },

    sortTable() {
      function templateId(a, b) {
        if (a.templateId < b.templateId) return -1;
        if (a.templateId > b.templateId) return 1;
        return 0;
      }
      function line_No(a, b) {
        if (a.line_No < b.line_No) return -1;
        if (a.line_No > b.line_No) return 1;
        return 0;
      }

      return this.table.desserts.sort(line_No).sort(templateId);
    },
  },

  watch: {},

  methods: {
    checkLength(index) {
      if (index < this.template.length - 1) {
        index = index + 1;
        return index;
      }
    },

    async preview() {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;

      let check = 0;
      this.table.desserts.forEach((key) => {
        if (key.qty != undefined || key.qty > 0) {
          check = check + key.qty;
        }
      });

      await check;

      if (check == 0) {
        this.$swal.fire({
          icon: "warning",
          title: "เลือกรายการสินค้า",
          text: "ยังไม่ได้เลือกรายการสินค้า",
        });

        return;
      }
      this.tableReview.desserts = [];
      this.table.desserts.forEach((key) => {
        if (parseInt(key.qty) > 0) {
          //  console.log(key)
          this.tableReview.desserts.push(key);
        }
      });
      this.dialogReview = true;
    },

    async save() {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      this.orderitem = [];

      if (this.tableReview.desserts.length == 0) {
        this.$swal.fire({
          icon: "warning",
          title: "เลือกรายการสินค้า",
          text: "ยังไม่ได้เลือกรายการสินค้า",
        });
        return;
      }

      //console.log( "NEW" +this.orderitem );
      this.tableReview.desserts.forEach((key, index) => {
        // console.log(key)

        let data = {};
        data.line_no = key.line_No;
        data.item = index + 1;
        data.templateId = key.templateId;
        data.orderid = "";
        data.itemcode = key.itemCode;
        data.qty = key.qty;
        data.price = key.price;

        this.orderitem.push(data);
      });

      try {
        let response = await this.$http({
          method: "post",

          url: "api/customerorder/SaveOrder",
          data: {
            orderHeader: this.orderheader,
            orderitem: this.orderitem,
            btnsaveconfirm: true,
          },
        });
        if (response.status == "200") {
          this.$swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลเรียบร้อย",
            text: "เลขที่ใบสั่งซื้อ" + response.data.docno,
          });

          this.orderheader.orderId = response.data.docno;

          this.btn = {
            btnadd: false,
            btnedit: false,
            btnsearch: false,
            btnprint: false,
            btnselectlist: true,
            btnsave: true,
            btnsaveconfirm: true,
            btndelete: true,
          };

          this.input = {
            duedate: true,
            tel: true,
            contact: true,
            remark: true,
            qty: true,
            template: true,
          };
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: response,
          });
        }

        this.dialogReview = false;
      } catch (error) {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      }
    },

    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/, ",");
    },

    parseDate(date) {
      if (!date) return null;
      // return moment(String(date)).format("MM/DD/YYYY");
      const [day, month, year] = date.split("/");
      //  return `${year}-${month}-${day}`;
      `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    add() {
      this.btn = {
        btnadd: true,
        btnedit: true,
        btnsearch: true,
        btnprint: true,
        btnselectlist: false,
        btnsave: false,
        btnsaveconfirm: false,
        btndelete: false,
      };
      this.input = {
        duedate: false,
        tel: false,
        contact: false,
        remark: false,
        qty: false,
        template: false,
      };

      this.orderheader = {
        id: 0,
        orderId: "",
        duedate: null,
        tel: "",
        customerid: parseInt(localStorage.getItem("customerid")),
        contactId: "",
        remark: "",
        docTotal: 0,
        statusDoc: "N",
      };
      this.$swal({
        title: "<span style='color: red;'>วันที่ 21/10/69 ไฟล์มีการอัพเดท</span>",
        text: "ต้องการโหลด Template ใหม่ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true, // เพิ่มเมื่อต้องการให้แสดงปุ่มยกเลิก
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        }).then((result) => {
        if (result.isConfirmed) {        
          //window.open("https://iadth-my.sharepoint.com/:f:/p/it01/EpZMtFAy4yhMonb5cMBRfAQB9ot6iaGm_Rhe3UvAhXqR1w", "_blank"); 
          window.open("https://www.iadth.com/downloadfile/Template21-10-69.xlsx", "_blank");
        }      
      });
      this.table.desserts = [];
    },

    print() {
      this.$http({
        method: "GET",
        url:
          "api/customerorder/PrintOrder/" +
          localStorage.getItem("customerid") +
          "/" +
          this.orderheader.orderId,
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.status == "200") {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "OrderId" + this.orderheader.orderId + ".pdf"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else if (response.status == "204")
          this.$swal.fire({
            icon: "error",
            text: "ไม่พบข้อมูล",
          });
      });
    },

    async edit() {
      // console.log(this.orderheader)
      if (this.orderheader.statusDoc != "N") {
        this.$swal.fire({
          icon: "warning",
          title: "Alert",
          text: "ข้อมูลนี้มีได้รับการสั่งซื้อเรียบร้อยแล้ว",
        });
        return;
      }

      try {
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/getorder/" +
            this.orderheader.orderId +
            "/" +
            localStorage.getItem("customerid"),
        });

        var list = await this.$http({
          method: "get",
          url: "api/customerorder/GetItemCode/" + this.orderheader.templateDoc,
        });

        if (list.status == "200") {
          list.data.data.templateitem.forEach((key) => {
            let itemcode = response.data.orderItem.filter(
              (item) => item.line_no == key.line_No
            );
            if (itemcode.length > 0) {
              // console.log(itemcode[0].qty)
              key.qty = itemcode[0].qty;
              key.price = itemcode[0].price;
              // key.line_No = index + 1;
              // listitem = list.data.data.templateitem;
            }
          });

          this.table.desserts = list.data.data.templateitem; //list.data.data.templateitem
        }
      } catch (error) {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      }

      this.btn = {
        btnadd: true,
        btnedit: true,
        btnsearch: true,
        btnprint: true,
        btnselectlist: false,
        btnsave: false,
        btnsaveconfirm: false,
        btndelete: false,
      };

      this.input = {
        duedate: false,
        tel: false,
        contact: false,
        remark: false,
        qty: false,
        template: false,
      };
    },

    cancel() {
      location.reload();
    },

    async selectList() {
      //alert('dd')
      // this.$v.$touch()
      if (this.$v.$pendding || this.$v.$error) return;

      this.tableTemplate.loading = true;
      this.tableTemplate.filters = "";

      try {
        var response = await this.$http({
          method: "get",
          url: "api/customerorder/GetItemCode",
        });

        if (response.status == "200") {
          var objdata = response.data.data.templateitem.filter(
            (d) => d.itemActive == "1"
          );

          this.tableTemplate.desserts = objdata;

          this.dialogTemplate = true;
        } else {
          this.$swal.fire({
            icon: "info",
            title: "Alert",
            text: "ไม่พบรายการสินค้า",
          });
        }
      } catch (error) {
        if (error.status == "401") {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: "ไม่พบสิทธิ์การใช้งาน",
          });
        } else if (status == "403") {
          this.$swal.fire({
            icon: "error",
            title: "Alert",
            text: "ไม่พบ  URL",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Alert",
            text: error.response.data + " " + error,
          });
        }
      }

      this.tableTemplate.loading = false;
    },

    async searchmodal() {
      this.$v.$touch();
      if (this.search.fromdate == "") {
        return;
      }
      if (this.search.todate == "") {
        return;
      }

      try {
        var params = new URLSearchParams();
        params.append("fromdate", this.search.fromdate);
        params.append("todate", this.search.todate);
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetHeader/" + localStorage.getItem("customerid"),
          params: params,
        });

        if (response.status == "200") {
          this.searchmodaldata.desserts = response.data.header;
        } else {
          this.$swal.fire({
            icon: "info",
            title: "ค้นหาข้อมูล",
            text: "ไม่พบข้อมูลการสั่งซื้อ",
          });
        }
      } catch (error) {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      }
    },

    onClickOutside() {
      this.overlay = false;
    },

    async selectheader(orderId) {
      //   this.$v.$touch();
      this.searchmodaldata.loading = true;

      this.orderheader = {
        id: 0,
        orderId: "",
        duedate: null,
        tel: "",
        customerid: parseInt(localStorage.getItem("customerid")),
        contactId: "",
        remark: "",
        docTotal: 0,
        statusDoc: "N",
      };

      this.table.desserts = [];

      try {
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/getorder/" +
            orderId +
            "/" +
            localStorage.getItem("customerid"),
        });
        if (response.status == "200") {
          this.modalsearch = false;

          this.orderheader = await response.data.orderHeader;

          var list = await this.$http({
            method: "get",
            url: "api/customerorder/GetItemCode",
          });

          if (list.status == "200") {
            var listitem;

            // console.log( list.data.data.templateitem);
            // console.log(response.data.orderItem)
            list.data.data.templateitem.forEach((key) => {
              let itemcode = response.data.orderItem.filter(
                (item) =>
                  item.line_no == key.line_No &&
                  item.templateId == key.templateId
              );

              if (itemcode.length > 0) {
                // console.log(item + ":" + key)
                key.qty = itemcode[0].qty;
                key.price = itemcode[0].price;

                // key.line_No = index + 1;
                // listitem = list.data.data.templateitem;
              } else {
                key.qty = 0;
                key.price = 0;
              }
            });

            listitem = await list.data.data.templateitem.filter(
              (qty) => qty.qty > 0
            );

            this.table.desserts = listitem; //list.data.data.templateitem // //
          }

          this.btn = {
            btnadd: false,
            btnedit: false,
            btnsearch: false,
            btnprint: false,
            btnselectlist: true,
            btnsave: true,
            btnsaveconfirm: false,
          };
          this.input = {
            duedate: true,
            tel: true,
            contact: true,
            remark: true,
            qty: true,
            template: true,
          };
        }
      } catch (error) {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      }

      this.searchmodaldata.loading = false;
    },

    async GetTel() {
      let telno = await this.contact.filter(
        (item) => item.contactId == this.orderheader.contactId
      );

      if (telno != undefined) {
        if (this.orderheader.tel == "") {
          this.orderheader.tel = this.orderheader.tel + telno[0].tel;
        } else {
          this.orderheader.tel = this.orderheader.tel + "," + telno[0].tel;
        }
      }
    },

    count() {
      this.orderheader.docTotal = 0;
      this.table.desserts.forEach((key) => {
        if (key.qty != undefined) {
          this.orderheader.docTotal += key.qty * key.price;
        }
      });
    },

    getimageitem(value) {
      this.imageitem = "";

      if (value.url == "" && value.fileName == "") {
        this.$swal.fire({
          icon: "info",
          title: "Alert",
          text: "ยังไม่ได้กำหนดรูปภาพ",
        });
        return;
      }

      if (value.fileType == "2") {
        this.imageitem = value.url;
        this.dialogimage = true;
      } else if (value.fileType == "1") {
        this.getpicblob(value);
      } else {
        this.$swal.fire({
          icon: "info",
          title: "Alert",
          text: "ยังไม่ได้กำหนดรูปภาพ",
        });
      }
    },

    getpicblob(value) {
      this.$http({
        method: "get",
        url: "api/customerorder/GetPictureItemCode/" + value.itemCode,
        responseType: "arraybuffer",
      })
        .then((response) => {
          if (response.status == "200") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            this.imageitem = url;
            this.dialogimage = true;
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            if (error.response.status == "401") {
              this.$swal.fire({
                icon: "error",
                title: "Authorize",
                text: "ไม่พบสิทธิ์การใช้งาน",
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              text: error.response.data.response.data,
            });
          }
        });
    },

    focusNext(elem) {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem);
      elem.form.elements
        .item(
          currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
        )
        .focus();
    },

    async selectdata() {
      let check = 0;
      this.tableTemplate.desserts.forEach((key) => {
        if (key.qty != undefined || key.qty > 0) {
          check = check + key.qty;
        }
      });
      await check;

      if (check == 0) {
        this.$swal.fire({
          icon: "warning",
          title: "เลือกรายการสินค้า",
          text: "ยังไม่ได้เลือกรายการสินค้า",
        });

        return;
      }

      for (var i = 0; i < this.tableTemplate.desserts.length; i++) {
        let add = 0;
        if (
          this.tableTemplate.desserts[i].qty != undefined ||
          this.tableTemplate.desserts[i].qty > 0
        ) {
          for (var row = 0; row < this.table.desserts.length; row++) {
            if (
              this.tableTemplate.desserts[i].line_No ==
                this.table.desserts[row].line_No &&
              this.tableTemplate.desserts[i].templateId ==
                this.table.desserts[row].templateId
            ) {
              this.table.desserts[row].qty =
                this.table.desserts[row].qty +
                this.tableTemplate.desserts[i].qty;

              add = 1;
            }
          }
          if (add == 0) {
            this.table.desserts.push(this.tableTemplate.desserts[i]);
          }
        }
      }

      this.dialogTemplate = false;
      this.count();
    },

    removerow(value) {
      console.log(value);
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "ต้องการลบรายการนี้ใช่ไหม",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.isConfirmed) {
            const index = this.table.desserts.indexOf(value);
            this.table.desserts.splice(index, 1);
          }
        });
    },

    async onfileselected() {
      try {
        var file = await this.fileexcel;

        const formData = new FormData();
        formData.append("file", file);

        var getexcel = this.$http({
          method: "POST",
          url: "api/CustomerOrder/ReadExcel",
          data: formData,
        });
        
        

        var getItem = this.$http({
          method: "get",
          url: "api/customerorder/GetItemCode",
        });

        var response = await getexcel;

        console.log(response);

        var list = await getItem;

        var listItem = [];

        this.orderheader.remark = response.data.remark;
        this.orderheader.tel = response.data.tel;

        response.data.item.forEach((key) => {
          let itemcode = list.data.data.templateitem.filter(
            (item) =>
              item.line_No === key.line_no && item.templateId === key.templateId
          );

          if (itemcode.length > 0) {
            var data = {};

            data.line_No = itemcode[0].line_No;
            data.templateId = key.templateId;
            data.itemCode = key.itemCode;
            data.itemName = itemcode[0].itemName;
            data.ugpName = itemcode[0].ugpName;
            data.currency = itemcode[0].currency;
            data.url = itemcode[0].url;
            data.fileType = itemcode[0].fileType;
            data.fileName = itemcode[0].fileName;
            data.itemActive = itemcode[0].itemActive;
            data.subGroup = itemcode[0].subGroup;
            data.price = key.price;
            data.qty = key.qty;

            listItem.push(data);
            // console.log(itemcode)
          }

          this.table.desserts = listItem; //list.data.data.templateitem // //
          this.count();
        });
      } catch (error) {
        if (error.response.status == "404") {
          this.$swal.fire({
            icon: "error",
            title: "Alert",
            text: error.response.statusText,
          });
        } else if (error.response.status == "401") {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: "ไม่พบสสิทธิ์การใช้งาน",
          });
        } else if (error.response.status == "204") {
          this.$swal.fire({
            icon: "info",
            title: "แจ้งเตือน",
            text: "ยังไม่ได้ใส่จำนวนใส่ไฟล์ Excel",
          });
        } else if (error.response.status == "403") {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: "ไม่พบสสิทธิ์การใช้งาน",
          });
        } else if (error.response.status == "500") {
          this.$swal.fire({
            icon: "error",
            title: "Alert",
            text: error.response.data.detail,
          });
        } else if (error.response.status == "400") {
          this.$swal.fire({
            icon: "error",
            title: "Alert",
            text: error.response.data,
          });
        } else if (error.request) {
          this.$swal.fire({
            icon: "error",
            title: "Error Requset",
            text: error.request.text,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Authorize",
            text: error.response,
          });
        }
      }
    },

    async readExcel() {
      try {
        let fileUpload = document.getElementById("fileexcel");

        if (fileUpload != null) {
          fileUpload.click();
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          text: error,
        });
      }
    },
  },

  validations: {
    template: { required },
    contact: { required },
    orderheader: {
      duedate: { required },
      contactId: { required },
      //templateDoc: { required },
    },
    //  name: { required, maxLength: maxLength(10) },
    // email: { required, email },
    //select: { required },
  },
};
</script>
<style></style>

<style></style>
